var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgCalendarClock = function SvgSvgCalendarClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18A2.252 2.252 0 0 1 0 15.75v-12A2.252 2.252 0 0 1 2.25 1.5H4.5V.75a.75.75 0 0 1 1.5 0v.75h6V.75a.75.75 0 0 1 1.5 0v.75h2.25A2.252 2.252 0 0 1 18 3.75v4.5a.75.75 0 0 1-1.5 0V7.5h-15v8.25c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6ZM16.5 6V3.75a.75.75 0 0 0-.75-.75H13.5v.75a.75.75 0 0 1-1.5 0V3H6v.75a.75.75 0 0 1-1.5 0V3H2.25a.75.75 0 0 0-.75.75V6h15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 24a6.758 6.758 0 0 1-6.75-6.75 6.758 6.758 0 0 1 6.75-6.75A6.758 6.758 0 0 1 24 17.25 6.758 6.758 0 0 1 17.25 24Zm0-12A5.256 5.256 0 0 0 12 17.25a5.256 5.256 0 0 0 5.25 5.25 5.256 5.256 0 0 0 5.25-5.25A5.256 5.256 0 0 0 17.25 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18a.75.75 0 0 1-.75-.75v-2.651a.75.75 0 0 1 1.5 0V16.5h1.902a.75.75 0 0 1 0 1.5H17.25Z",
    fill: "currentColor"
  })));
};
export default SvgSvgCalendarClock;